const getProductQuantityPcb = (product, qtity): any => {
  if (product?.purchased_qty) {
    const maxQuantityAvailable =
      Number(product.purchased_qty) > Number(product.amount)
        ? Number(product.amount)
        : Number(product.purchased_qty)

    return Math.round(maxQuantityAvailable / product.coeffQuantity) * product.coeffQuantity
  }

  if (product?.prices_current?.length > 1 && qtity == 0) {
    return 0
  }

  if (qtity == 0) return product.coeffQuantity
  return qtity * product.coeffQuantity
}

export default getProductQuantityPcb
